import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import Modal from '../../../../Components/Modal/Modal';
import QuestionnairePickerList from './QuestionnairePickerList';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';

interface Props {
	onSelect: (questionnaire: SelectValue) => void;
	module?: QuestionnaireModule;
}

const QuestionnairePicker: React.FC<Props> = ({ onSelect, module }) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleSelectQuestionnaire = (questionnaire: SelectValue) => {
		onSelect(questionnaire);
		setIsOpen(false);
	};

	return (
		<div>
			<LinkButton
				title='component.questionnairePicker.pickFromList'
				theme={Theme.BLUE}
				onClick={() => setIsOpen(true)}
			/>
			<Modal opened={isOpen} onClose={() => setIsOpen(false)}>
				<Modal.Header title='component.questionnairePicker.pickQuestionnaire' />
				<Modal.Content>
					<QuestionnairePickerList
						onSelect={handleSelectQuestionnaire}
						module={module}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
};

export default QuestionnairePicker;
